@if (btnCancelShow$$()) {
    <app-button-action
        (btnClick)="emit_btnCancel()"
        [buttonData]="btnCancelData$$()"
        [tooltip]="btnCancelTooltip$$()"
    >
        <app-icon name="xmark" [@show] />
    </app-button-action>
}
@if (btnSaveShow$$()) {
    <app-button-action
        (btnClick)="emit_btnSave()"
        [buttonData]="btnSaveData$$()"
        [loadKey]="loadKey.pageLock"
        [lockOnLoad]="input_LockOnLoad$$()"
        [tooltip]="btnSaveTooltip$$()"
        >
        <app-icon name="save" [@show] />
    </app-button-action>
}
<ng-container *ngTemplateOutlet="input_TemplateButtons$$()"></ng-container>
